import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { GameRewards } from 'src/AngularJS/Goals/Gamification/Models/game-history';
import { GameActionObject } from 'src/app/dashboard/modules/cxone-games/game.models';
import { GameType } from 'src/app/gamification/command-center/models/games.model';
import { Budget } from 'src/app/gamification/cv-admin/models/budget.model';
import { BudgetService } from 'src/app/gamification/cv-admin/services/budget/budget.service';
import { GenericMetricFormatterPipe } from 'src/app/reusables/pipes/generic-metric-formatter.pipe';
import { IHGameStandardize, IHSelectedMetric, ParticipantObj, NumericType, TimeType} from '../../../models/games-parameter.model';
import { GamesParameterHistoryService } from '../../../services/games-parameter-history.service';
import { GamesService } from '../../../services/games.service';
import { GamificationMainService } from '../../../services/gamification-main.service';
import { Game, GameHistoryParams, Qualifier, Interval } from './selected-game.model';
import { GameHistoryBreakdownEffectivenessComponent } from '../games-history-health-components/game-history-breakdown-effectiveness/game-history-breakdown-effectiveness.component';
import { DatePipe } from '@angular/common';
import { HealthReportTopPerformersComponent } from '../games-history-health-components/health-report-top-performers/health-report-top-performers.component';

const MAX_RECENT_DAYS = 30; // Max number of days in which a game is considered recent
interface GroupedData {
    count: number;
    hasTargetDate: boolean;
    hasValidActionType: boolean;
    hasCollected: boolean;
}

@Component({
    selector: 'cv-games-history-health-report',
    templateUrl: './games-history-health-report.component.html',
    styleUrls: ['./games-history-health-report.component.scss']
})

export class GamesHistoryHealthReportComponent implements OnInit, OnChanges {
    @ViewChild(GameHistoryBreakdownEffectivenessComponent) GameEffectiveness!: GameHistoryBreakdownEffectivenessComponent;
    @ViewChild(HealthReportTopPerformersComponent) TopPerformers!: HealthReportTopPerformersComponent;
    @ViewChild('Rewards_Collected', { static: false }) rewards_collected: ElementRef;
    @ViewChild('Collect_Button', { static: false }) collect_button: ElementRef;
    HealthReportTopPerformersComponent
    @Input() intervalSelected: Interval[];
    @Input() selectedGame: Game | null = null;
    @Input() endDate: string = null;
    @Input() participants: ParticipantObj[];
    @Input() gameRewards: GameRewards[] = null;
    @Input() gameActions!: GameActionObject;
    private cache: Map<string, any> = new Map();

    _loadingGameParams = true;
    GameTypeEnum = GameType;
    historyGame: IHGameStandardize = null
    gs = null;
    isLoading: boolean = true;
    qualifierType: string = "";
    qualifierLeft: string;
    qualifierRight: string;
    previousQualifier: Qualifier;
    gameHistoryParams: GameHistoryParams;
    sumCoins: number = 0;
    sumPlayers: number = 0;
    sumXP: number = 0;
    sumBadges: number = 0;
    sumCustomRewards: number = 0;
    budgetPercentage: number = 0;
    joinedCount: number = 0;
    firstAverageMetricValue: number = null;
    isCollectButtonActive: boolean = false;
    autoJoin: boolean = false;
    budget: Budget = {
        budgetList: [],
        total: "",
        initBudgetList: []
    };
    collectedCount;
    collectedPercentage: number;
    metricList: IHSelectedMetric[] = [];
    gameMetric: IHSelectedMetric;
    qualifier: IHSelectedMetric;
    component: { Qualifier: { conversionType: string; }; }[];
    groupedParticipantRewards: Record<string, GroupedData> = {};
    countParticipantRewards: number = 0;
    exportData = null;
    gameEffectiveness: any[];
    metricResults: any;
    topPerformers: any;

    constructor(
        private metricFormatter: GenericMetricFormatterPipe,
        private formattedMetricPipe: GenericMetricFormatterPipe,
        private cdRef: ChangeDetectorRef,
        private gamesParameterHistoryService: GamesParameterHistoryService,
        private gamesService: GamesService,
        private budgetService: BudgetService,
        private gamificationService: GamificationMainService,
        private datePipe: DatePipe,
    ) {
        this.gs = this.gamesService.data;
    }

    ngOnInit(): void {
        this.loadBudgetandCollectButtonSettings();
    }

    async ngOnChanges(changes: SimpleChanges): Promise<void> {
        if (changes.endDate?.currentValue || changes.selectedGame?.currentValue && changes.selectedGame.currentValue.RuleID) {
            this.selectedGame = changes.selectedGame?.currentValue || this.selectedGame;
            this.endDate = changes.endDate?.currentValue?.split('T')[0] || this.endDate;
            this.gameActions = changes.gameActions?.currentValue || this.gameActions;
            if (this.selectedGame.RuleID > 0 && this.endDate) {
                this._loadingGameParams = true;
                this.gamesParameterHistoryService.loadGameHistoryParams(this.selectedGame.RuleID, this.endDate).then((game) => {
                    this.historyGame = game;
                }).finally(() => {
                    this.gameHistoryParams = this.gamesParameterHistoryService.getGame(this.selectedGame.RuleID, this.endDate);
                    this._loadingGameParams = false;
                    this.firstAverageMetricValue = null;
                    this.getMetrics();
                });
            }
        }

        if (changes.participants && changes.participants.currentValue) {
            this.participants = changes.participants?.currentValue;
            this.sumPlayers = this.participants.reduce((sum, current) => sum + 1, 0);
            this.sumCoins = this.participants.filter((a: any) => { return a.calculatedCoins >= 0; }).reduce((sum, current) => sum + current.calculatedCoins, 0);
            this.sumXP = this.participants.filter((a: any) => { return a.calculatedXP >= 0; }).reduce((sum, current) => sum + current.calculatedXP, 0);
            this.sumBadges = this.participants.reduce((sum, current) => sum + current.badges.length, 0);
            this.sumCustomRewards = this.participants.filter((a: ParticipantObj) => a.custom?.length > 0 && !a.isReverted).length;
            this.joinedCount = this.participants
                .flatMap(p => p.participant)
                .filter((p: any) => p.AlreadyJoined === true)
                .length;
        }

        if (changes.gameRewards && changes.gameRewards.currentValue) {
            const gameRewards = changes.gameRewards.currentValue;

            // Getting the target date (one day before EndDate)
            const endDate = new Date(this.intervalSelected[0]?.EndDate);
            endDate.setDate(endDate.getDate() - 1);
            const targetDate = endDate.toISOString().split("T")[0];

            this.groupedParticipantRewards = gameRewards.reduce((acc, reward) => {
                const login = reward.LoginName;
                if (!acc[login]) {
                    acc[login] = { count: 0, hasTargetDate: false, hasValidActionType: false, hasCollected: false };
                }

                // Only count if ActionType is not 10 (10= custom Reward)
                if (reward.ActionType !== 10) {
                    acc[login].count++;
                    acc[login].hasValidActionType = true;
                }

                // Check if the reward was collected
                if (reward.Collected) {
                    acc[login].hasCollected = true;
                }

                // Extract only the YYYY-MM-DD part of the ActionDate
                const actionDate = reward.ActionDate.split("T")[0];
                if (actionDate === targetDate) {
                    acc[login].hasTargetDate = true;
                }

                return acc;
            }, {} as Record<string, GroupedData & { hasValidActionType: boolean; hasCollected: boolean }>);

            this.groupedParticipantRewards = Object.fromEntries(
                Object.entries(this.groupedParticipantRewards).filter(([_, data]) => data.hasValidActionType)
            );

            // number of participants who received a prize
            this.countParticipantRewards = Object.keys(this.groupedParticipantRewards).length;

            //number of participants who collected the prize
            this.collectedCount = Object.entries(this.groupedParticipantRewards)
            .filter(([_, data]) => data.hasCollected)
            .length;
        }

        if (changes['selectedGame']) {
            this.autoJoin = this.selectedGame.underlyingRule.AutoJoin;
        }
        this.cdRef.detectChanges();
    }

    get timeSinceLastUpdate() {
        if (!this.selectedGame || !this.endDate) return '';
        return this.gamesParameterHistoryService.getTimeSinceLastUpdate(this.selectedGame.RuleID, this.endDate);
    }

    get isRecentlyAdded() {
        if (!this.selectedGame || !this.endDate) return '';
        return this.gamesParameterHistoryService.isRecentlyAdded(this.selectedGame.RuleID, this.endDate, MAX_RECENT_DAYS);
    }

    get participantsPercentage() {
        if (this.joinedCount === 0 || this.sumPlayers === 0) return 0;
        const percentage = parseFloat(((this.joinedCount / this.sumPlayers) * 100).toFixed(2));

        if (percentage % 1 === 0) {
            return parseInt(percentage.toFixed(0));
        }

        return percentage;
    }

    get collectedRewardsPercentage() {
        if (this.collectedCount === 0 || this.countParticipantRewards === 0) return 0;
        const percentage = parseFloat(((this.collectedCount / this.countParticipantRewards) * 100).toFixed(2));

        if (percentage % 1 === 0) {
            return parseInt(percentage.toFixed(0));
        }
        return percentage;
    }

    get isPercentageGreaterThan75(): boolean {
        return this.participantsPercentage >= 75;
    }

    get iscollectedPercentageGreaterThan75(): boolean {
        return this.collectedRewardsPercentage >= 75;
    }

    get noRewards(): boolean {
        return this.sumBadges == 0 && this.sumBadges == 0 && this.sumXP == 0;
    }

    editGame() {
        this.gamesService.clearContext();
        this.gamesService.pushContext('landing');
        this.gamesService.pushContext('history');
        this.gamesService.pushContext('edit');
        this.gs.currentView = 0;
        this.gamesService.navigateTo({ type: 'edit', game: this.selectedGame, folder: { FolderData: { FolderID: this.gs.selectedGame[0].FolderID } } });
    }

    getMetrics() {
        const metrics = this.gamesParameterHistoryService.getMetrics(this.selectedGame.RuleID, this.endDate);

        if (this.selectedGame?.GameType == GameType.Raffle) {
            this.gameMetric = metrics.length > 0 ? metrics[0] : null;
            this.qualifier = metrics.length > 0 ? metrics[1] : null;
        }
        else if (this.selectedGame?.GameType != GameType.Connect3 && this.selectedGame?.GameType != GameType.Blackout) {
            this.gameMetric = metrics.length > 0 ? metrics.find(x => !x.IsQualifier) : null;
            this.qualifier = metrics.find(x => x.IsQualifier);
        } else {
            this.metricList = metrics.filter(x => !x.IsQualifier).sort((a, b) => a.Position - b.Position);
            this.gameMetric = this.metricList[0];
            this.qualifier = metrics.find(x => x.IsQualifier);
        }
        this.cdRef.detectChanges(); 
    }

    metricAvg(metricID: number, conversionType: number) {
        const firstValidParticipant = this.participants?.find(p => p.ruleObject !== null);

        if (this.endDate && (this.firstAverageMetricValue !== null || this.participants?.length === 0 || this.participants?.length > 0)) {
            this.isLoading = false;
        } else {
            if (this.endDate == null) this.isLoading = false;
            else this.isLoading = true;
        }

        if (firstValidParticipant?.ruleObject?.MyRankingObj?.MetricGroupInfos) {
            const foundMetric = firstValidParticipant.ruleObject.MyRankingObj.MetricGroupInfos
                .find(metric => metric.MetricID === metricID);

            this.firstAverageMetricValue = foundMetric ? foundMetric.AverageMetricValue : null;

            if (foundMetric === null && this.participants?.length > 0) {
                this.isLoading = false;
            }
        } else {
            if (this.participants?.length > 0) {
                this.isLoading = false;
            }
        }

        return this.gamesService.formatterMetricData(conversionType.toString(), this.firstAverageMetricValue);
    }

    getConnect3InitialPosition() {
        const metricPosition = this.metricList.find(
            (position: any) =>
                position.Position === 0
        );

        if (metricPosition) {
            return {
                direction: metricPosition.MetricDetail.DefaultMetricDirection === 0 ? '<' : '>',
                formattedData: this.getFormattedData(
                    metricPosition.LeftNumber,
                    metricPosition.MetricDetail.ConversionType
                )
            };
        }

        return null;
    }

    getFormattedData(value: any, conversionType: any): string {
        return this.metricFormatter.transform(value, conversionType.toString());
    }

    async loadBudgetandCollectButtonSettings() {
        const budgetList = await this.budgetService.loadBudgets();
        this.budget.budgetList = budgetList?.map((budget) => ({
            ...budget,
            AmountString: budget.Amount.toString(),
        })).sort((a, b) => a.GroupLevelName.localeCompare(b.GroupLevelName, undefined, { sensitivity: 'base' }));
        this.budget.initBudgetList = [...this.budget.budgetList];
        await this.gamificationService.loadGlobalSettings();
        this.isCollectButtonActive = this.gamificationService.data.globalSettings.CollectButton;
    }

    get percentageBudget() {
        if (!this.budget?.budgetList?.length || !this.budget.budgetList[0]?.Amount || this.sumCoins === 0) {
            return 0;
        }

        const percentage = parseFloat(((this.sumCoins / this.budget.budgetList[0].Amount) * 100).toFixed(2));

        if (percentage % 1 === 0) {
            return parseInt(percentage.toFixed(0));
        }

        return percentage;
    }

    getLocalizedText(key: string, defaultText: string): string {
        return this.gamesService.getLocalizedMessage(key, defaultText);
    }

    async getAllTopPerformers() {
        let startDate = this.TopPerformers.getStartDateByEndDate(this.endDate, this.intervalSelected);
        this.topPerformers = [];
        const metricsArray = Object.values(this.gameHistoryParams.HMetricDetails);
        for (const metric of metricsArray) {
            const result = await this.gamesParameterHistoryService.getTopPerformers(
                this.selectedGame.RuleID,
                startDate,
                this.endDate,
                metric.MetricID,
                this.qualifier?.MetricID
            );
            let topPerformersData = [];
            if (result !== undefined) {
                topPerformersData = result.map(item => ({
                    ...item,
                    MetricName: metric.Abbrev
                }));
            }
            this.topPerformers.push(...topPerformersData);
        }
        return this.topPerformers;
    }

    async getAllGameEffectivenessData() {
        if (this.participants) {
            const formattedParticipants = this.participants.map(({ participant }) => ({
                ...participant,
                GroupID: participant.RelatedGroupID
            })) || [];
            const previousStartDate = this.GameEffectiveness.getPreviousStartDate();
            const firstPreviousDate = previousStartDate[0];
            const formattedFirstPreviousDate = new Date(firstPreviousDate).toISOString().replace(/\.\d{3}Z$/, '');

            this.metricResults = await Promise.all(
                this.gameHistoryParams.HistorySelectedMetrics.map(async (metric) => {
                    return await this.gamesService.LoadMetricRanking(
                        metric.MetricID.toString(),
                        formattedParticipants,
                        formattedFirstPreviousDate,
                        this.intervalSelected[0].EndDate,
                        true
                    );
                })
            );

            this.gameEffectiveness = this.metricResults.flat();
            this.calculateAverage();
        }

        this.gameEffectiveness?.forEach(effectiveness => {
            if (!effectiveness?.IntervalAverages) {
                effectiveness.IntervalAverages = [
                    {
                        AverageValue: 0,
                        Date: this.intervalSelected[0].EndDate || new Date(),
                        FormattedDate: '',
                        FormattedValue: "---"
                    }
                ]; // default average
            }
            effectiveness.IntervalAverages.forEach(interval => {
                const adjustedDate = new Date(interval.Date);
                adjustedDate.setMinutes(adjustedDate.getMinutes() + adjustedDate.getTimezoneOffset());
                interval.FormattedDate = this.GameEffectiveness.formatDate(adjustedDate);
            });
        });

        return this.gameEffectiveness || [];
    }

    calculateAverage() {
        const currentdates = this.GameEffectiveness.gamePeriodDates;
        const previusDates = this.GameEffectiveness.previousPeriodDates;
        const metricsArray = Object.values(this.gameHistoryParams.HMetricDetails);

        this.gameEffectiveness = this.metricResults.map(metric => {
            if (!metric.IntervalAverages || metric.IntervalAverages.length === 0) {
                return { ...metric, AverageValue: 0, PreviousAverage: 0 };
            }
            const metricDetail = metricsArray.find(m => m.MetricID === metric.MetricID);
            const direction = metricDetail ? metricDetail.DefaultMetricDirection : null;
            const directionText = direction === 1 ? this.getLocalizedText("Up", "Up") : this.getLocalizedText("Down", "Down");

            const formattedIntervalAverages = metric.IntervalAverages.map(item => {
                const [year, month, day] = item.Date.split('T')[0].split('-');
                const date = new Date(Number(year), Number(month) - 1, Number(day));
                return {
                    ...item,
                    Date: this.datePipe.transform(date, 'MM/dd') || ''
                };
            });

            const valuesInPeriod = formattedIntervalAverages
                .filter(item => currentdates.includes(item.Date))
                .map(item => item.AverageValue);

            const valuesInPreviousPeriod = formattedIntervalAverages
                .filter(item => previusDates.includes(item.Date))
                .map(item => item.AverageValue);

            const averageValue = valuesInPeriod.length > 0
                ? valuesInPeriod.reduce((acc, value) => acc + value, 0) / valuesInPeriod.length
                : 0;

            const previousAverage = valuesInPreviousPeriod.length > 0
                ? valuesInPreviousPeriod.reduce((acc, value) => acc + value, 0) / valuesInPreviousPeriod.length
                : 0;

            const currentValue = this.GameEffectiveness.parseNumericValue(averageValue.toString());
            const previousValue = this.GameEffectiveness.parseNumericValue(previousAverage.toString());
            const difference = currentValue - previousValue;
            let sign = difference >= 0 ? '+ ' : '- ';
            let formattedValue = this.GameEffectiveness.formatMetricDisplayValue(Math.abs(difference));
            let formattedTime = '';
            
            if (metric.NumericType === NumericType.Time &&
                metric.TimeType === TimeType.Time) {
                const absoluteDiff = Math.abs(difference);
                formattedTime = this.GameEffectiveness.formatMetricTime(absoluteDiff);
            }

            formattedValue = this.GameEffectiveness.formatMetricDisplayValue(Math.abs(difference));

            return {
                ...metric,
                AverageValue: this.GameEffectiveness.formatMetricDisplayValue(averageValue),
                PreviousAverage: this.GameEffectiveness.formatMetricDisplayValue(previousAverage),
                Difference: metric.NumericType === NumericType.Time && metric.TimeType === TimeType.Time
                    ? `${sign}${formattedTime}`
                    : `${sign}${formattedValue}`,
                Direction: directionText
            };
        });
    }

  async setDataForexportGHR() {
    // Creating a unique key based on ruleID and intervalSelected
    const cacheKey = this.getCacheKey(this.selectedGame.RuleID,  this.gs.selectedInterval[0]?.DisplayStringDate);

    // Check if data is cached
    if (this.cache.has(cacheKey)) {
      // If the data is already cached, return the cached data
      return this.cache.get(cacheKey);
    }

    // If they are not cached, make the requests
    const [gameEffectiveness, topPerformers] = await Promise.all([
      this.getAllGameEffectivenessData(),
      this.getAllTopPerformers()
    ]);

    const exportData = this.createExportData(gameEffectiveness, topPerformers);
    this.cache.set(cacheKey, exportData);

    return exportData;
  }

  private getCacheKey(ruleID: number, selectedInterval: any): string {
    return `${ruleID}-${selectedInterval}`;
  }

  private createExportData(gameEffectiveness: any, topPerformers: any) {
    let Frequency = null;
    if (this.gameHistoryParams) {
      switch (this.gameHistoryParams.IntervalType) {
        case 0:
          Frequency = this.getLocalizedText('Daily', 'Daily');
          break;
        case 1:
          Frequency = this.getLocalizedText('Weekly', 'Weekly');
          break;
        case 2:
          Frequency = this.getLocalizedText('Monthly', 'Monthly');
          break;
        default:
          break;
      }
    }

    if (this.selectedGame.GameType === this.GameTypeEnum.Brackets){
      Frequency = this.getLocalizedText('N_A', 'N/A');
    }

    // Setting game details info
    let Participation = this.joinedCount + "/" + this.sumPlayers + " " + this.participantsPercentage + "%";
    let RewardsCollected = this.isCollectButtonActive
        ? this.collectedCount + "/" + this.gameRewards.length + " " + this.collectedRewardsPercentage + "%"
        : this.getLocalizedText('Collect_Button_Disabled', 'Collect Button disabled');
    let PercentageBudget = this.percentageBudget + "% " + this.getLocalizedText('Of_Total_Coins_Budget', 'of total coins budget');
    let Metric = this.gameMetric?.MetricDetail?.Name + " " + this.getLocalizedText('Avg', 'Avg') + " "  + this.metricAvg(this.gameMetric?.MetricDetail?.MetricID, this.gameMetric?.MetricDetail?.ConversionType)
        + (this.selectedGame.GameType == this.GameTypeEnum.Connect3 || this.selectedGame.GameType == this.GameTypeEnum.Blackout ? ' +' + (this.selectedGame.SelectedMetrics.length - 1) + this.getLocalizedText('Metrics', 'Metrics') : '');
    let Qualifier = this.qualifier != undefined ? this.qualifier.MetricDetail.Abbrev +" "+ this.getLocalizedText('Avg', 'Avg') + " "+ this.metricAvg(this.qualifier?.MetricDetail?.MetricID, this.qualifier?.MetricDetail?.ConversionType): this.getLocalizedText('None', 'None');

    if (gameEffectiveness !== undefined && gameEffectiveness !== null) {
        this.exportData = {
            ghObjects: this.participants,
            game: {
                ...this.selectedGame,
                GameDetails: {
                    Frequency,
                    Participation,
                    RewardsCollected,
                    PercentageBudget,
                    TotalCoins: this.sumCoins,
                    TotalXP: this.sumXP,
                    TotalBadges: this.sumBadges,
                    GamePeriod: this.GameEffectiveness.gamePeriod,
                    PreviousPeriod: this.GameEffectiveness.previousPeriod,
                    Metric,
                    Qualifier
                }
            },
            gameEffectivenessData: gameEffectiveness,
            topPerformersData: topPerformers,
        };
    }
    return this.exportData;
  }

    checkTextTruncation(tooltip: string, type: string): string {

        switch (type) {
            case "Rewards_Collected":
                if (this.rewards_collected) {
                    return this.rewards_collected.nativeElement.scrollWidth !== this.rewards_collected.nativeElement.clientWidth ? tooltip : "";
                }
                break;
            case "Collect_Button":
                if (this.collect_button) {
                    return this.collect_button.nativeElement.scrollWidth !== this.collect_button.nativeElement.clientWidth ? tooltip : "";
                }
                break;
            default: return "";
        }
    }
}
